import React from 'react'
import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
import { useTheme } from '@emotion/react'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper'
import { Add } from '@mui/icons-material'
import { Box, Button, Card, CardContent, CardHeader, CircularProgress, Divider, Grid, IconButton, LinearProgress, Menu, MenuItem, Tooltip, Typography, useMediaQuery, Dialog } from '@mui/material'
import fundingRoundsBackground from "assets/rounds_icons/funding_rounds_background.webp"
import { FetchAllRounds, ChangeRoundStatus } from 'api/org/round'
import { ReactComponent as SecurityIcon } from "assets/rounds_icons/security_icon.svg"
import { ReactComponent as ViewIcon } from "assets/rounds_icons/view_icon.svg"
import { ReactComponent as MoreIcon } from "assets/rounds_icons/more_icon.svg"
import { useNavigate } from 'react-router-dom'
import rocket_rounds_image from "assets/rounds_icons/rocket_rounds_image.png"
import PerfectScrollbar from "react-perfect-scrollbar"
import moment from 'moment'
import NoRounds from './NoRounds'
import { containerRef, handleDateValues, hasPermission } from 'utils'
import { useSelector } from 'react-redux'
// import { FetchStartupDetails } from 'api/profile'
import { ReactComponent as EditIcon } from "assets/rounds_icons/edit_icon.svg";
import UpdateRoundStatusPopup from './popups/UpdateRoundStatusPopup'
import ModalComponent from "ui-components/ModalComponent"
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import { useToast } from 'context/ToastContext'
import { Primary } from 'ui-components/Buttons';

const Rounds = ({ startup_name, setShowRoundForm = () => { }, startup_slug }) => {
  const theme = useTheme()
  const { addToast } = useToast();
  let [startup_id, setStartupID] = React.useState(Cookies.get("startup_id") || null);
  const isNotLargeScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const matchUpSm = useMediaQuery(theme.breakpoints.up('lg'));
  const matchDownSm = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate()
  const details = useSelector((state) => state?.startupDetails?.data);
  const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
  // const {data: details, isLoading} = FetchStartupDetails();
  const { data: roundsData, isLoading: isLoadingRounds, mutateAsync: mutateAsyncRounds } = FetchAllRounds()
  const { isLoading: isChangingRoundStatus, mutateAsync: changeRoundStatusAsync } = ChangeRoundStatus()

  const refetchRoundsData = () => {
    // console.log(startup_id, hasPermission("startups", "view", userPermissions), userPermissions)
    startup_id && hasPermission("startups_new", "view", userPermissions) && mutateAsyncRounds({ startup_id });
  }

  const setStartupName = () => {
    startup_name && Cookies.set("selected_startup_name", startup_name)
    Cookies.set("startup_slug", startup_slug)
  }

  React.useEffect(() => {
    refetchRoundsData();
    Cookies.remove("round_id")
  }, [startup_id, userPermissions])

  const RoundActions = () => {
    return (
      hasPermission("funding_rounds", "add", userPermissions) ?
        <Primary onClick={() => {
          Cookies.remove("round_id");
          setStartupName();
          navigate("/startups/rounds/add-round")
        }} sx={{ padding: '10px 16px', fontWeight: 600, minWidth: isSmallScreen ? "0" : '64px', '& > .MuiButton-icon.MuiButton-startIcon': { marginRight: isSmallScreen ? 0 : '8px', marginLeft: isSmallScreen ? 0 : '-4px' } }} startIcon={<Add fontSize='1.25rem' />}>
          {!isSmallScreen ? "Add Round" : ''}
        </Primary>
        :
        <NeedHelpButton />

    )
  }

  const [selectedRound, setSelectedRound] = React.useState(null)

  const handleOpenStatusModal = ({ round }) => {
    setSelectedRound(round);
  }

  const handleCloseStatusModal = () => {
    setSelectedRound(null)
  }

  const handleUpdateRoundStatus = ({ round }) => {
    // console.log(round,"round")
    changeRoundStatusAsync({ payload: round, startup_id: startup_id }).then((successResponse) => {
      // if()
      // console.log(successResponse?.data?.statusCode,"successResponse")
      if (successResponse?.data?.statusCode !== 200) {
        // toast.error(successResponse?.data?.message)
        addToast(successResponse?.data?.message, "error")
      }
      else {
        // toast.success(successResponse?.data?.message)
        addToast(successResponse?.data?.message, "success")
      }
      handleCloseStatusModal();
      refetchRoundsData()
    }).catch((err) => console.log("error", 'err'))
  }

  const RoundCard = ({ data: cardData, key: index }) => {
    // popper more menu
    // const [currentIndex, setCurrentIndex] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClickMenu = (event, index) => {
      setAnchorEl(event.currentTarget);
      // setCurrentIndex(index)
      // console.log(event.currentTarget,"re")
    };
    const handleCloseMenu = (event) => {
      // console.log(event,"event")
      setAnchorEl(null);
      // setCurrentIndex(null);
    };

    const [copied, setCopied] = React.useState(false);
    const startDateValue = cardData?.final_round_start_date && cardData?.final_round_start_date?.trim()?.length > 0 ? cardData?.final_round_start_date?.trim() : null
    const closingDateValue = cardData?.final_round_closing_date && cardData?.final_round_closing_date?.trim()?.length > 0 ? cardData?.final_round_closing_date?.trim() : null
    // console.log(startDateValue, closingDateValue, 'startDateValue')
    return (
      <Grid key={index} item xs={12} sm={6}
      // sm={5.8}
      //  md={5.8}
      //   lg={5.9}
      >
        <Card sx={{ borderRadius: "10px", border: `1px solid ${theme.palette.customColors.b50}`, overflow: 'hidden', boxShadow: 'none' }}>
          {matchUpSm && <CardHeader
            sx={{ background: theme.palette.customColors.white, borderBottom: `1px solid ${theme.palette.customColors.b50}`, "& > .MuiCardHeader-avatar": { maxWidth: { xs: "39%", md: "39%" }, marginRight: "8px" }, "& > .MuiCardHeader-action": { maxWidth: "65%" } }}
            avatar={
              <>
                <Box display="flex" sx={{ gap: 1, alignItems: "center", flexDirection: "column", width: "100%" }}>
                  <Typography
                    fontWeight={700}
                    width="100%"
                    fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }}
                    color={theme.palette.customColors.g300}
                    sx={{
                      cursor: 'pointer',
                      wordBreak: 'break-all',
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                    onClick={() => {
                      Cookies.set("round_id", cardData?._id)
                      Cookies.set("startup_slug", startup_slug)
                      setStartupName();
                      navigate(`/startups/rounds/view`)
                    }
                    }
                  >
                    {cardData?.round_name && cardData?.round_name !== "" ? cardData?.round_name : '-'}{" "}
                    {cardData?.round_type_info?.name && cardData?.round_type_info?.name !== "" ? `(${cardData?.round_type_info?.name})` : "-"}
                  </Typography>
                </Box>
              </>
            }

            action={
              <>
                <Box display={"flex"} gap={2}>
                  <Grid item xs={12} display={"flex"} justifyContent={"space-between"} >
                    <Box display={"flex"} flexDirection={{ xs: "column", lg: 'row' }} sx={{ gap: { xs: 0.5, lg: 0.5 }, alignItems: "center" }}>

                      {startDateValue && closingDateValue && <Box>
                        <Typography bgcolor={"#E2F0FF"} color={"#0075FF"} fontWeight={700} fontSize={"0.7rem"} padding={"5px 7px"} mt={0} width={"max-content"} borderRadius={"4px"}>
                          {handleDateValues(cardData?.final_round_start_date, "No Start Date")} - {handleDateValues(cardData?.final_round_closing_date, "No Closing Date")}
                        </Typography>
                      </Box>}

                      <Box>
                        <Typography sx={{ fontSize: '0.8rem', bgcolor: '#D2F2E7', color: "#1B8662", fontWeight: 700, padding: "6px 8px", borderRadius: "4px", textTransform: 'uppercase', lineHeight: "10px", ":hover": { bgcolor: "ActiveColor" }, cursor: 'pointer' }} onClick={() => handleOpenStatusModal({ round: cardData })}>
                          {cardData?.round_status_info ? isNotLargeScreen ? cardData?.round_status_info?.name : cardData?.round_status_info?.name : '-'}
                        </Typography>
                      </Box>
                      <Box display={"flex"} sx={{ gap: 0.5, alignItems: "center" }}>
                        <SecurityIcon width={'0.8rem'} height={'0.8rem'} />
                        <Typography sx={{ color: theme.palette.customColors.g300, fontWeight: 500, fontSize: '0.8rem' }}>
                          {cardData?.security_type_info?.name ? cardData?.security_type_info?.name : "-"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Box height={"100%"} display={"contents"}>
                    <IconButton sx={{ padding: 0, marginBlock: 'auto' }} onClick={(e) => handleClickMenu(e, index)} aria-label="more">
                      <MoreIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      id="account-menu"
                      open={openMenu}
                      aria-controls={openMenu ? 'fade-menu' : 'fade-menu'}
                      aria-haspopup="true"
                      aria-expanded={openMenu ? 'true' : 'false'}
                      onClose={handleCloseMenu}
                      onClick={handleCloseMenu}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: 'visible',
                          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                          mt: 1.5,
                          padding: "12px",
                          borderRadius: "8px",
                          "& > ul.MuiList-root": { padding: "0 !important" },
                          bgcolor: theme.palette.customColors.g400,
                          color: theme.palette?.customColors?.whiteBG,
                          '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 11,
                            width: 10,
                            height: 10,
                            bgcolor: theme.palette.customColors.g900,
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                      <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                        Cookies.set("round_id", cardData?._id)
                        Cookies.set("startup_slug", startup_slug)
                        setStartupName();
                        navigate(`/startups/rounds/view`)
                      }}>
                        View Details
                      </MenuItem>
                      <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                        Cookies.set("round_id", cardData?._id)
                        Cookies.set("startup_slug", startup_slug)
                        setStartupName();
                        navigate(`/startups/rounds/view-investors`)
                      }}>
                        Investors
                      </MenuItem>
                      <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                        Cookies.set("round_id", cardData?._id)
                        Cookies.set("startup_slug", startup_slug)
                        setStartupName();
                        navigate(`/startups/rounds/view-documents`)
                      }}>
                        Documents
                      </MenuItem>
                      {hasPermission("startups_new", "edit", userPermissions) &&
                        <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleOpenStatusModal({ round: cardData })}>
                          Change Status
                        </MenuItem>}
                      {hasPermission("startups_new", "edit", userPermissions) &&
                        <MenuItem disableRipple sx={{ padding: '0.625rem 1rem' }} onClick={() => {
                          Cookies.set("round_id", cardData?._id)
                          Cookies.set("startup_slug", startup_slug)
                          setStartupName();
                          navigate(`/startups/rounds/edit-round`)
                        }}>
                          Edit Round
                        </MenuItem>}
                    </Menu>
                  </Box>
                </Box>
              </>
            }
          />}
          {matchDownSm && <Grid xs={12} container sx={{ background: theme.palette.customColors.white, borderBottom: `1px solid ${theme.palette.customColors.b50}` }}>

            <Grid item xs={12} padding={"0.5rem 1rem 0.5rem 1rem"} display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: `1px solid ${theme.palette.customColors.b50}` }}>
              <Typography
                fontWeight={700}
                width="100%"
                fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }}
                color={theme.palette.customColors.g300}
                sx={{
                  cursor: 'pointer',
                  wordBreak: 'break-all',
                  overflowWrap: "break-word",
                  whiteSpace: "normal",
                }}
                onClick={() => {
                  Cookies.set("round_id", cardData?._id)
                  Cookies.set("startup_slug", startup_slug)
                  setStartupName();
                  navigate(`/startups/rounds/view`)
                }
                }
              >
                {cardData?.round_name && cardData?.round_name !== "" ? cardData?.round_name : '-'}{" "}
                {cardData?.round_type_info?.name && cardData?.round_type_info?.name !== "" ? `(${cardData?.round_type_info?.name})` : "-"}
              </Typography>
              <Box height={"100%"} display={"contents"}>
                <IconButton sx={{ padding: 0, marginBlock: 'auto' }} onClick={(e) => handleClickMenu(e, index)} aria-label="more">
                  <MoreIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={openMenu}
                  aria-controls={openMenu ? 'fade-menu' : 'fade-menu'}
                  aria-haspopup="true"
                  aria-expanded={openMenu ? 'true' : 'false'}
                  onClose={handleCloseMenu}
                  onClick={handleCloseMenu}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 1.5,
                      padding: "12px",
                      borderRadius: "8px",
                      "& > ul.MuiList-root": { padding: "0 !important" },
                      bgcolor: theme.palette.customColors.g400,
                      color: theme.palette?.customColors?.whiteBG,
                      '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 11,
                        width: 10,
                        height: 10,
                        bgcolor: theme.palette.customColors.g900,
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                    Cookies.set("round_id", cardData?._id)
                    Cookies.set("startup_slug", startup_slug)
                    setStartupName();
                    navigate(`/startups/rounds/view`)
                  }}>
                    View Details
                  </MenuItem>
                  <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                    Cookies.set("round_id", cardData?._id)
                    Cookies.set("startup_slug", startup_slug)
                    setStartupName();
                    navigate(`/startups/rounds/view-investors`)
                  }}>
                    Investors
                  </MenuItem>
                  <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                    Cookies.set("round_id", cardData?._id)
                    Cookies.set("startup_slug", startup_slug)
                    setStartupName();
                    navigate(`/startups/rounds/view-documents`)
                  }}>
                    Documents
                  </MenuItem>
                  <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleOpenStatusModal({ round: cardData })}>
                    Change Status
                  </MenuItem>
                  <MenuItem disableRipple sx={{ padding: '0.625rem 1rem' }} onClick={() => {
                    Cookies.set("round_id", cardData?._id)
                    Cookies.set("startup_slug", startup_slug)
                    setStartupName();
                    navigate(`/startups/rounds/edit-round`)
                  }}>
                    Edit Round
                  </MenuItem>
                </Menu>
              </Box>
            </Grid>
            <Grid item xs={12} padding={"0.5rem 1rem 0.5rem 1rem"} display={"flex"} justifyContent={"space-between"} alignItems={"center"} >
              {startDateValue && closingDateValue &&
                <Box>
                  <Typography bgcolor={"#E2F0FF"} color={"#0075FF"} fontWeight={700} fontSize={"0.7rem"} padding={"5px 7px"} mt={0} width={"max-content"} borderRadius={"4px"}>
                    {handleDateValues(cardData?.final_round_start_date, "No Start Date")} - {handleDateValues(cardData?.final_round_closing_date, "No Closing Date")}
                  </Typography>
                </Box>}

              <Box display={"flex"} alignItems={"center"} gap={0.5}>
                <Box>
                  <Typography sx={{ fontSize: '0.8rem', bgcolor: '#D2F2E7', color: "#1B8662", fontWeight: 700, padding: "6px 8px", borderRadius: "4px", textTransform: 'uppercase', lineHeight: "10px", ":hover": { bgcolor: "ActiveColor" }, cursor: 'pointer' }} onClick={() => handleOpenStatusModal({ round: cardData })}>
                    {cardData?.round_status_info ? isNotLargeScreen ? cardData?.round_status_info?.name : cardData?.round_status_info?.name : '-'}
                  </Typography>
                </Box>
                <Box display={"flex"} sx={{ gap: 0.5, alignItems: "center" }}>
                  <SecurityIcon width={'0.8rem'} height={'0.8rem'} />
                  <Typography sx={{ color: theme.palette.customColors.g300, fontWeight: 500, fontSize: '0.8rem' }}>
                    {cardData?.security_type_info?.name ? cardData?.security_type_info?.name : "-"}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <>
              {/* <Box display="flex" sx={{ gap: 1, alignItems: "center", flexDirection: "column", width: "100%" }}>
                <Typography
                  fontWeight={700}
                  width="100%"
                  fontSize={{ xs: "0.8rem", md: "0.9rem" }}
                  color={theme.palette.customColors.g300}
                  sx={{
                    cursor: 'pointer',
                    wordBreak: 'break-all',
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                  }}
                  onClick={() => {
                    Cookies.set("round_id", cardData?._id)
                    navigate(`/rounds/view`)
                  }
                  }
                >
                  {cardData?.round_name && cardData?.round_name !== "" ? cardData?.round_name : '-'}{" "}
                  {cardData?.round_type_info?.name && cardData?.round_type_info?.name !== "" ? `(${cardData?.round_type_info?.name})` : "-"}
                </Typography>
                {isNotLargeScreen && (
                  startDateValue && closingDateValue &&
                  <Typography
                    bgcolor={"#E2F0FF"}
                    color={"#0075FF"}
                    fontWeight={700}
                    fontSize={"0.75rem"}
                    padding={"4px 6px"}
                    mt={0}
                    width={"max-content"}
                    borderRadius={"4px"}
                  >
                    {handleDateValues(cardData?.final_round_start_date, "No Start Date")} - {handleDateValues(cardData?.final_round_closing_date, "No Closing Date")}
                  </Typography>
                )}
              </Box> */}
              {/* <Box display={"flex"} gap={2}>
                <Grid item xs={12} display={"flex"} justifyContent={"space-between"} >
                  <Box display={"flex"} flexDirection={{ xs: "column", lg: 'row' }} sx={{ gap: { xs: 0.5, lg: 0.5 }, alignItems: "center" }}>
                    {!isNotLargeScreen && (
                      startDateValue && closingDateValue &&
                      <Box>
                        <Typography bgcolor={"#E2F0FF"} color={"#0075FF"} fontWeight={700} fontSize={"0.7rem"} padding={"5px 7px"} mt={0} width={"max-content"} borderRadius={"4px"}>
                          {handleDateValues(cardData?.final_round_start_date, "No Start Date")} - {handleDateValues(cardData?.final_round_closing_date, "No Closing Date")}
                        </Typography>
                      </Box>
                    )}
                    <Box>
                      <Typography sx={{ fontSize: '0.8rem', bgcolor: '#D2F2E7', color: "#1B8662", fontWeight: 700, padding: "6px 8px", borderRadius: "4px", textTransform: 'uppercase', lineHeight: "10px", ":hover": { bgcolor: "ActiveColor" }, cursor: 'pointer' }} onClick={() => handleOpenStatusModal({ round: cardData })}>
                        {cardData?.round_status_info ? isNotLargeScreen ? cardData?.round_status_info?.name : cardData?.round_status_info?.name : '-'}
                      </Typography>
                    </Box>
                    <Box display={"flex"} sx={{ gap: 0.5, alignItems: "center" }}>
                      <SecurityIcon width={'0.8rem'} height={'0.8rem'} />
                      <Typography sx={{ color: theme.palette.customColors.g300, fontWeight: 500, fontSize: '0.8rem' }}>
                        {cardData?.security_type_info?.name ? cardData?.security_type_info?.name : "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Box height={"100%"} display={"contents"}>
                  <IconButton sx={{ padding: 0, marginBlock: 'auto' }} onClick={(e) => handleClickMenu(e, index)} aria-label="more">
                    <MoreIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={openMenu}
                    aria-controls={openMenu ? 'fade-menu' : 'fade-menu'}
                    aria-haspopup="true"
                    aria-expanded={openMenu ? 'true' : 'false'}
                    onClose={handleCloseMenu}
                    onClick={handleCloseMenu}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        padding: "12px",
                        borderRadius: "8px",
                        "& > ul.MuiList-root": { padding: "0 !important" },
                        bgcolor: theme.palette.customColors.g400,
                        color: theme.palette?.customColors?.whiteBG,
                        '&::before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 11,
                          width: 10,
                          height: 10,
                          bgcolor: theme.palette.customColors.g900,
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                      Cookies.set("round_id", cardData?._id)
                      navigate(`/rounds/view`)
                    }}>
                      View Details
                    </MenuItem>
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                      Cookies.set("round_id", cardData?._id)
                      navigate(`/rounds/view-investors`)
                    }}>
                      Investors
                    </MenuItem>
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => {
                      Cookies.set("round_id", cardData?._id)
                      navigate(`/rounds/view-documents`)
                    }}>
                      Documents
                    </MenuItem>
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={() => handleOpenStatusModal({ round: cardData })}>
                      Change Status
                    </MenuItem>
                    <MenuItem disableRipple sx={{ padding: '0.625rem 1rem' }} onClick={() => {
                      Cookies.set("round_id", cardData?._id)
                      navigate(`/rounds/edit_round`)
                    }}>
                      Edit Round
                    </MenuItem>
                  </Menu>
                </Box>
              </Box> */}
            </>
          </Grid>}
          <CardContent sx={{ paddingBottom: "0 !important", cursor: 'pointer', }} onClick={() => {
            Cookies.set("round_id", cardData?._id)
            Cookies.set("startup_slug", startup_slug)
            navigate(`/startups/rounds/view`)
          }} >
            <Grid container sx={{
              padding: '0.75rem',
              gap: '1rem',
              borderRadius: '8px',
              border: `1px solid ${theme.palette.customColors.b75}`,
              background: theme.palette.customColors.b50,
              display: 'flex',
              justifyContent: "space-between",
              flexWrap: 'wrap'
            }}>
              <Grid item width={{ xs: '100%', md: '59%' }} display={"grid"} gap={2}>
                <Grid item xs={12} display={"flex"} justifyContent={"space-between"}>
                  <Grid item>
                    <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }} fontWeight={700} color={theme.palette.customColors.g300}>
                      {cardData?.total_round_size_final ? cardData?.total_round_size_final : "-"}
                    </Typography>
                    <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }}>
                      Total Round Size
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }} fontWeight={700} color={theme.palette.customColors.g300}>
                      {cardData?.total_interested_amount_final ? cardData?.total_interested_amount_final : '-'}
                    </Typography>
                    <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }}>
                      Committed Amount
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} display={"flex"} flexDirection={"column-reverse"}>
                  <LinearProgress value={cardData?.percentage} variant='determinate' sx={{ borderRadius: '5px', background: "white", "& > .MuiLinearProgress-bar": { background: theme.palette.customColors.purple_dark } }} />
                </Grid>
              </Grid>
              <Grid item width={{ xs: "100%", md: "35%" }} sx={{ background: theme.palette.customColors.purple_dark, color: theme.palette.customColors.whiteBG, padding: '0.75rem 1rem', borderRadius: '8px' }}>
                <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }} fontWeight={700}>
                  {/* {cardData?.currency_info}132K */}
                  {cardData?.total_allocated_amount_final ? cardData?.total_allocated_amount_final : '-'}
                </Typography>
                <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }}>
                  Amount Received
                </Typography>
              </Grid>
            </Grid>
            <Grid container display={"flex"} justifyContent={"space-between"} xs={12} mt={"1rem"} paddingBottom={2}>
              <Grid item xs={12} display={"grid"}>
                {/* <Grid item xs={12} display={"flex"} justifyContent={"space-between"} mb={1}>
                  <Box display={"flex"} sx={{ gap: 1, alignItems: "center" }}>
                    <SecurityIcon width={'1.25rem'} height={'1.25rem'} />
                    <Typography sx={{ color: theme.palette.customColors.g300, fontWeight: 500, fontSize: '1.125rem' }}>
                      {cardData?.security_type_info?.name ? cardData?.security_type_info?.name : "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ bgcolor: '#D2F2E7', color: "#1B8662", fontWeight: 700, padding: "6px 8px", borderRadius: "4px", textTransform: 'uppercase' }}>
                      {cardData?.round_status_info ? isNotLargeScreen ? cardData?.round_status_info?.name : cardData?.round_status_info?.name + " ROUND" : '-'}
                    </Typography>
                  </Box>
                </Grid> */}
                <Grid item container display={"flex"} alignItems={"center"} justifyContent={"space-between"} xs={12}>
                  <Grid item xs={5.8} md={5.8} lg={5.9} sx={{ padding: '0.75rem', border: `1px solid ${theme.palette.customColors.g50}`, borderRadius: '8px' }}>
                    <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }} fontWeight={700} color={theme.palette.customColors.g300}>
                      {/* {cardData?.investors ? cardData?.investors?.length : 0} */}
                      {cardData?.total_investor ? cardData?.total_investor : 0}
                    </Typography>
                    <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }}>
                      Investors
                    </Typography>
                  </Grid>
                  <Grid item xs={5.8} md={5.8} lg={5.9} sx={{ padding: '0.75rem', border: `1px solid ${theme.palette.customColors.g50}`, borderRadius: '8px' }}>
                    <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }} fontWeight={700} color={theme.palette.customColors.g300}>
                      {cardData?.round_valuation_final ? cardData?.round_valuation_final : "-"}
                    </Typography>
                    <Typography fontSize={{ xs: "0.9rem", sm: "0.8rem", md: "0.9rem", lg: "1rem" }}>
                      Valuation
                    </Typography>
                  </Grid>
                </Grid>
                {/* <Grid>
                  <Typography bgcolor={"#E2F0FF"} color={"#0075FF"} fontWeight={700} fontSize={"0.75rem"} padding={"6px 8px"} mt={1} width={"max-content"} borderRadius={"4px"}>
                    {handleDateValues(cardData?.final_round_start_date, "No Start Date")} - {handleDateValues(cardData?.final_round_closing_date, "No Closing Date")}
                  </Typography>
                </Grid> */}
              </Grid>
              {/* <Grid item xs={3}>
                              <img src={rocket_rounds_image} style={{ height: 188, width: 188, marginBottom: -6 }} />
                            </Grid> */}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    )
  }

  // console.log(roundsData,"roundsData")

  return (
    <>
      {/* /Modals Start/ */}
      <Dialog open={Boolean(selectedRound)} onClose={handleCloseStatusModal} aria-labelledby="update-Status-dialog" sx={{ "& > .MuiDialog-container > .MuiPaper-root": { minWidth: 400 } }}>
        <UpdateRoundStatusPopup selectedRound={selectedRound} handleClose={handleCloseStatusModal} handleSubmit={handleUpdateRoundStatus} isLoading={false} open={Boolean(selectedRound)} />
      </Dialog>
      {/* /Modals End/   */}
      {/* <ThemeBGWrapper bgColor={theme.palette.customColors.yellow_bg}> */}
      {/* <BreadcrumbHeader title="Funding Rounds" breadcrumbTitle='Funding Rounds' customBackgroundColor={theme.palette.customColors.indigo25} Actions={RoundActions} /> */}
      {
        isLoadingRounds ?
          <PerfectScrollbar
            containerRef={containerRef}
            style={{ height: "calc(100vh - 170px)", overflowX: 'hidden' }}>
            {/* <Grid item xs={12} display={"grid"} height={"100vh"} sx={{ placeContent: 'center' }}> */}
            {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}

            <Grid container xs={12} padding={{ xs: "0 1rem 1rem 1rem", md: "0 2rem 2rem 2rem" }} justifyContent={"space-between"} rowGap={4} columnGap={2}>
              {/* {!isNotLargeScreen && <Grid className="skeleton" item xs={12} sx={{ height: 232, width: '100%', borderRadius: '10px' }}>

              </Grid>} */}
              <Grid className="skeleton" item xs={12} sm={5.8} lg={5.9} sx={{ minHeight: { xs: 300, sm: 350, md: 380 }, width: '100%', borderRadius: '10px' }}>

              </Grid>
              <Grid className="skeleton" item xs={12} sm={5.8} lg={5.9} sx={{ minHeight: { xs: 300, sm: 350, md: 380 }, width: '100%', borderRadius: '10px' }}>

              </Grid>
              <Grid className="skeleton" item xs={12} sm={5.8} lg={5.9} sx={{ minHeight: { xs: 300, sm: 350, md: 380 }, width: '100%', borderRadius: '10px' }}>

              </Grid>
              <Grid className="skeleton" item xs={12} md={5.8} lg={5.9} sx={{ minHeight: { xs: 300, sm: 350, md: 380 }, width: '100%', borderRadius: '10px' }}>

              </Grid>
            </Grid>
            {/* </Grid>  */}
          </PerfectScrollbar>
          :
          <>
            {roundsData?.data?.data && roundsData?.data?.data?.length > 0 &&
              <PerfectScrollbar
                containerRef={containerRef}
                style={{ height: "calc(100vh - 170px)" }}>
                {/* {!isNotLargeScreen && <Box sx={{ paddingInline: "2rem" }}>
                  <img loading='lazy' src={fundingRoundsBackground} style={{ width: '100%', maxHeight: '232.3px', height: '100%' }} />
                </Box>} */}
                <Grid container xs={12} padding={{ xs: "0 0rem 1rem 1rem", md: "0 1rem 2rem 2rem" }} spacing={2} justifyContent={"space-between"}>
                  {
                    roundsData?.data?.data?.map((round, index) => <RoundCard data={round} key={index} />)
                  }
                </Grid>

              </PerfectScrollbar>}
            {(Boolean(roundsData?.data?.data) === false || (roundsData?.data?.data?.length === 0)) && <NoRounds />}
          </>}
      {/* </ThemeBGWrapper> */}
    </>
  )
}

export default Rounds